module.exports = __webpack_public_path__ + "static/media/03.08fa93e4.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/dayup/home/03.png
// module id = 796
// module chunks = 0